import TextArea from "antd/es/input/TextArea";
import React from "react";

function TextAreaInput({ label, value, placeholder, onChange, rows, errors, maxLength }) {
  return (
    <div className="input-box">
      <label>{label}</label>
      <TextArea
        rows={rows}
        placeholder={placeholder}
        maxLength={maxLength}
        value={value}
        onChange={onChange}
      />
      {errors && <span style={{ color: "red" }}>{errors}</span>}
    </div>
  );
}

export default TextAreaInput;
